// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar-chart-axisTick-ArvHe {
  fill: var(--color-neutral-500);
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/bar-chart/bar-chart.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":[".axisTick {\n  fill: var(--color-neutral-500);\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"axisTick": `bar-chart-axisTick-ArvHe`
};
export default ___CSS_LOADER_EXPORT___;
